import React, { useState, useEffect, useContext } from "react";
import { ContextBoard } from "../../context/ContextBoard";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";

function EditSchool() {
  const navigate = useNavigate();
  const { secondaryAdminSchoolCode } = useContext(ContextBoard);
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  const token = sessionStorage.getItem("secondaryAdminToken");
  const [loading, setLoading] = useState(true);

  const [previewMode, setPreviewMode] = useState(false);
  const isDisabled = previewMode;

  const [stateList, setStateList] = useState([]);
  const [stateListX, setStateListX] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [districtListX, setDistrictListX] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [blockListX, setBlockListX] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [subDivisionListX, setSubDivisionListX] = useState([]);

  const [typeOfSchoolOptions, setTypeOfSchoolOptions] = useState([]);
  const [typeOfSchoolOptionsX, setTypeOfSchoolOptionsX] = useState([]);

  const [class9limit, setClass9limit] = useState("");
  const [class10limit, setClass10limit] = useState("");
  const [class9limitspecialexam, setClass9limitspecialexam] = useState("");
  const [class10limitspecialexam, setClass10limitspecialexam] = useState("");

  const initialSchoolInfo = {
    schooL_CODE: "",
    udisE_CODE: "",
    schooL_NAME: "",
    sC_ADDRESS: "",
    piN_CODE: "",
    area: "",
    posT_OFFICE: "",
    nearesT_RAILWAY_STATION: "",
    challaN_LIMIT: "",
    challaN_LIMIT_CL_10: "",
    challaN_LIMIT_S_EXAM_CL_9: "",
    challaN_LIMIT_S_EXAM_CL_10: "",
    heaD_NAME: "",
    heaD_MOBILE_NO: "",
    emaiL_ADDRESS: "",
    asstistencE_TEACHER_CONTACT: "",
  };

  const [schoolInfo, setSchoolInfo] = useState(initialSchoolInfo);
  const [schoolInfoX, setSchoolInfoX] = useState({ ...initialSchoolInfo });

  const [selectedState, setSelectedState] = useState("");
  const [selectedStateX, setSelectedStateX] = useState("");
  const [typeofschool, setTypeofschool] = useState("");
  const [typeofschoolX, setTypeofschoolX] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedDistrictX, setSelectedDistrictX] = useState("");
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedBlockX, setSelectedBlockX] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [selectedSubDivisionX, setSelectedSubDivisionX] = useState("");
  const [copyDirection, setCopyDirection] = useState("");
  const [udiseSource, setUdiseSource] = useState("");
  const [schoolCodeSource, setSchoolCodeSource] = useState("");

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!permissions[1]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);

  const toOptions = (list, valueKey, labelKey) =>
    list.map((item) => ({
      value: item[valueKey],
      label: item[labelKey],
    }));

  const fetchSchoolDetails = async () => {
    if (!secondaryAdminSchoolCode) {
      navigate("/secondary-admin-school-list");
      return;
    }

    setLoading(true);
    try {
      const request = (url, endpoint) =>
        fetch(`${url}/${endpoint}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ schooL_CODE: secondaryAdminSchoolCode }),
        }).then(async (response) => ({ response, data: await response.json() }));

      const [result9, result10] = await Promise.all([
        request(config.API_BASE_URL, "PageLoadSchoolData_CL9"),
        request(config.API_BASE_URL2, "PageLoadSchoolData_CL10"),
      ]);
      const groupData9 = result9.data?.data || {};
      const groupData10 = result10.data?.data || {};
      const school9 = groupData9.schoolDetails?.[0] || {};
      const school10 = groupData10.schoolDetails?.[0] || {};


      if (!result9.response.ok && !result10.response.ok) {
        throw new Error("Unable to fetch school information");
      }

      setStateList(groupData9.stateList || []);
      setDistrictList(groupData9.districtList || []);
      setBlockList(groupData9.blockList || []);
      setSubDivisionList(groupData9.divisionlist || []);
      setTypeOfSchoolOptions((groupData9.schoolType || []).map((type) => ({
        value: type.typE_OF_SCHOOL,
        label: type.typE_OF_SCHOOL,
      })));
      setStateListX(groupData10.stateList || []);
      setDistrictListX(groupData10.districtList || []);
      setBlockListX(groupData10.blockList || []);
      setSubDivisionListX(groupData10.divisionlist || []);
      setTypeOfSchoolOptionsX((groupData10.schoolType || []).map((type) => ({
        value: type.typE_OF_SCHOOL,
        label: type.typE_OF_SCHOOL,
      })));

      setSchoolInfo(school9);
      setSchoolInfoX(school10);
      setClass9limit(school9.challaN_LIMIT || "");
      setClass10limit(school10.challaN_LIMIT_CL_10 || "");
      setClass9limitspecialexam(school9.challaN_LIMIT_S_EXAM_CL_9 || "");
      setClass10limitspecialexam(school10.challaN_LIMIT_S_EXAM_CL_10 || "");

      const stateOption = (school, lookupData) => school.state ? {
        value: school.state,
        label: (lookupData.stateList || []).find((item) => item.statE_CODE === school.state)?.statE_NAME || school.state,
      } : "";
      const districtOption = (school, lookupData) => {
        const value = school.districT_CODE || school.district;
        return value ? {
          value,
          label: (lookupData.districtList || []).find((item) => item.districT_CODE === value || item.disT_CODE === value)?.district || value,
        } : "";
      };
      const blockOption = (school, lookupData) => {
        const value = school.blocK_ID || school.blocK_NAME;
        return value ? {
          value,
          label: (lookupData.blockList || []).find((item) => item.blocK_ID === value || item.blocK_NAME === value)?.blocK_NAME || value,
        } : "";
      };
      const subdivisionOption = (school, lookupData) => school.suB_DIVISION ? {
        value: school.suB_DIVISION,
        label: (lookupData.divisionlist || []).find((item) => item.divisioN_ID === school.suB_DIVISION)?.divisioN_NAME || school.suB_DIVISION,
      } : "";

      setSelectedState(stateOption(school9, groupData9));
      setSelectedDistrict(districtOption(school9, groupData9));
      setSelectedBlock(blockOption(school9, groupData9));
      setSelectedSubDivision(subdivisionOption(school9, groupData9));
      setSelectedStateX(stateOption(school10, groupData10));
      setSelectedDistrictX(districtOption(school10, groupData10));
      setSelectedBlockX(blockOption(school10, groupData10));
      setSelectedSubDivisionX(subdivisionOption(school10, groupData10));
      setTypeofschool(school9.typE_OF_SCHOOL ? { value: school9.typE_OF_SCHOOL, label: school9.typE_OF_SCHOOL } : "");
      setTypeofschoolX(school10.typE_OF_SCHOOL ? { value: school10.typE_OF_SCHOOL, label: school10.typE_OF_SCHOOL } : "");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    } else {
      fetchSchoolDetails();
    }
  }, [secondaryAdminSchoolCode]);

  const filteredDistricts = selectedState
    ? districtList.filter((d) => d.statE_CODE === selectedState.value)
    : [];
  const filteredBlocks = selectedDistrict
    ? blockList.filter((b) => b.disT_CODE === selectedDistrict.value)
    : [];
  const filteredSubDivisions = selectedDistrict
    ? subDivisionList.filter((s) => s.district === selectedDistrict.value)
    : [];

  const filteredDistrictsX = selectedStateX
    ? districtListX.filter((d) => d.statE_CODE === selectedStateX.value)
    : [];
  const filteredBlocksX = selectedDistrictX
    ? blockListX.filter((b) => b.disT_CODE === selectedDistrictX.value)
    : [];
  const filteredSubDivisionsX = selectedDistrictX
    ? subDivisionListX.filter((s) => s.district === selectedDistrictX.value)
    : [];

  const nonCopyableFields = [
    "schooL_CODE",
    "udisE_CODE",
    "challaN_LIMIT",
    "challaN_LIMIT_CL_10",
    "challaN_LIMIT_S_EXAM_CL_9",
    "challaN_LIMIT_S_EXAM_CL_10",
  ];

  const handleSelectChange = (level, value) => {
    switch (level) {
      case "state":
        setSelectedState(value);
        setSchoolInfo((prev) => ({ ...prev, state: value?.value || "" }));
        setSelectedDistrict("");
        setSelectedBlock("");
        setSelectedSubDivision("");
        if (copyDirection === "9to10") {
          setSelectedStateX(value);
          setSchoolInfoX((prev) => ({ ...prev, state: value?.value || "" }));
          setSelectedDistrictX("");
          setSelectedBlockX("");
          setSelectedSubDivisionX("");
        }
        break;
      case "district":
        setSelectedDistrict(value);
        setSchoolInfo((prev) => ({ ...prev, district: value?.value || "" }));
        setSelectedBlock("");
        setSelectedSubDivision("");
        if (copyDirection === "9to10") {
          setSelectedDistrictX(value);
          setSchoolInfoX((prev) => ({ ...prev, district: value?.value || "" }));
          setSelectedBlockX("");
          setSelectedSubDivisionX("");
        }
        break;
      case "block":
        setSelectedBlock(value);
        setSchoolInfo((prev) => ({ ...prev, blocK_NAME: value?.value || "" }));
        if (copyDirection === "9to10") {
          setSelectedBlockX(value);
          setSchoolInfoX((prev) => ({ ...prev, blocK_NAME: value?.value || "" }));
        }
        break;
      case "subdivision":
        setSelectedSubDivision(value);
        setSchoolInfo((prev) => ({ ...prev, suB_DIVISION: value?.value || "" }));
        if (copyDirection === "9to10") {
          setSelectedSubDivisionX(value);
          setSchoolInfoX((prev) => ({ ...prev, suB_DIVISION: value?.value || "" }));
        }
        break;
      default:
        break;
    }
  };

  const handleSelectChangeX = (level, value) => {
    switch (level) {
      case "state":
        setSelectedStateX(value);
        setSchoolInfoX((prev) => ({ ...prev, state: value?.value || "" }));
        setSelectedDistrictX("");
        setSelectedBlockX("");
        setSelectedSubDivisionX("");
        if (copyDirection === "10to9") {
          setSelectedState(value);
          setSchoolInfo((prev) => ({ ...prev, state: value?.value || "" }));
          setSelectedDistrict("");
          setSelectedBlock("");
          setSelectedSubDivision("");
        }
        break;
      case "district":
        setSelectedDistrictX(value);
        setSchoolInfoX((prev) => ({ ...prev, district: value?.value || "" }));
        setSelectedBlockX("");
        setSelectedSubDivisionX("");
        if (copyDirection === "10to9") {
          setSelectedDistrict(value);
          setSchoolInfo((prev) => ({ ...prev, district: value?.value || "" }));
          setSelectedBlock("");
          setSelectedSubDivision("");
        }
        break;
      case "block":
        setSelectedBlockX(value);
        setSchoolInfoX((prev) => ({ ...prev, blocK_NAME: value?.value || "" }));
        if (copyDirection === "10to9") {
          setSelectedBlock(value);
          setSchoolInfo((prev) => ({ ...prev, blocK_NAME: value?.value || "" }));
        }
        break;
      case "subdivision":
        setSelectedSubDivisionX(value);
        setSchoolInfoX((prev) => ({ ...prev, suB_DIVISION: value?.value || "" }));
        if (copyDirection === "10to9") {
          setSelectedSubDivision(value);
          setSchoolInfo((prev) => ({ ...prev, suB_DIVISION: value?.value || "" }));
        }
        break;
      default:
        break;
    }
  };

  const copySchoolData = (direction) => {
    if (direction === "9to10") {
      setSchoolInfoX((prev) => ({
        ...prev,
        schooL_NAME: schoolInfo.schooL_NAME || "",
        sC_ADDRESS: schoolInfo.sC_ADDRESS || "",
        typE_OF_SCHOOL: schoolInfo.typE_OF_SCHOOL || "",
        piN_CODE: schoolInfo.piN_CODE || "",
        area: schoolInfo.area || "",
        posT_OFFICE: schoolInfo.posT_OFFICE || "",
        nearesT_RAILWAY_STATION: schoolInfo.nearesT_RAILWAY_STATION || "",
        heaD_NAME: schoolInfo.heaD_NAME || "",
        heaD_MOBILE_NO: schoolInfo.heaD_MOBILE_NO || "",
        emaiL_ADDRESS: schoolInfo.emaiL_ADDRESS || "",
        asstistencE_TEACHER_CONTACT: schoolInfo.asstistencE_TEACHER_CONTACT || "",
      }));
      setSelectedStateX(selectedState);
      setSelectedDistrictX(selectedDistrict);
      setSelectedBlockX(selectedBlock);
      setSelectedSubDivisionX(selectedSubDivision);
      setCopyDirection("9to10");
    } else if (direction === "10to9") {
      setSchoolInfo((prev) => ({
        ...prev,
        schooL_NAME: schoolInfoX.schooL_NAME || "",
        sC_ADDRESS: schoolInfoX.sC_ADDRESS || "",
        typE_OF_SCHOOL: schoolInfoX.typE_OF_SCHOOL || "",
        piN_CODE: schoolInfoX.piN_CODE || "",
        area: schoolInfoX.area || "",
        posT_OFFICE: schoolInfoX.posT_OFFICE || "",
        nearesT_RAILWAY_STATION: schoolInfoX.nearesT_RAILWAY_STATION || "",
        heaD_NAME: schoolInfoX.heaD_NAME || "",
        heaD_MOBILE_NO: schoolInfoX.heaD_MOBILE_NO || "",
        emaiL_ADDRESS: schoolInfoX.emaiL_ADDRESS || "",
        asstistencE_TEACHER_CONTACT: schoolInfoX.asstistencE_TEACHER_CONTACT || "",
      }));
      setSelectedState(selectedStateX);
      setSelectedDistrict(selectedDistrictX);
      setSelectedBlock(selectedBlockX);
      setSelectedSubDivision(selectedSubDivisionX);
      setCopyDirection("10to9");
    }
  };

  const clearSchoolData = (target) => {
    if (target === "10") {
      setSchoolInfoX((prev) => ({
        ...prev,
        schooL_NAME: "",
        sC_ADDRESS: "",
        typE_OF_SCHOOL: "",
        piN_CODE: "",
        area: "",
        posT_OFFICE: "",
        nearesT_RAILWAY_STATION: "",
        heaD_NAME: "",
        heaD_MOBILE_NO: "",
        emaiL_ADDRESS: "",
        asstistencE_TEACHER_CONTACT: "",
      }));
      setSelectedStateX("");
      setSelectedDistrictX("");
      setSelectedBlockX("");
      setSelectedSubDivisionX("");
    } else if (target === "9") {
      setSchoolInfo((prev) => ({
        ...prev,
        schooL_NAME: "",
        sC_ADDRESS: "",
        typE_OF_SCHOOL: "",
        piN_CODE: "",
        area: "",
        posT_OFFICE: "",
        nearesT_RAILWAY_STATION: "",
        heaD_NAME: "",
        heaD_MOBILE_NO: "",
        emaiL_ADDRESS: "",
        asstistencE_TEACHER_CONTACT: "",
      }));
      setSelectedState("");
      setSelectedDistrict("");
      setSelectedBlock("");
      setSelectedSubDivision("");
    }
  };

  const toggleCopyDirection = (direction) => {
    if (copyDirection === direction) {
      setCopyDirection("");
      if (direction === "9to10") {
        clearSchoolData("10");
      } else if (direction === "10to9") {
        clearSchoolData("9");
      }
      return;
    }
    copySchoolData(direction);
  };

  const handleInputChange = (e) => {
    const { name, value, dataset } = e.target;
    const formType = dataset?.formType || "9";
    let newValue = value;

    if (typeof newValue !== "string") {
      newValue = String(newValue);
    }

    if (/[|]/.test(newValue)) return;
    if (/\s{2,}/.test(newValue)) return;

    if (name === "schooL_NAME" || name === "sC_ADDRESS") {
      if (/[|]/.test(newValue)) return;
      newValue = newValue.toUpperCase();
    }

    if (name === "typE_OF_SCHOOL" || name === "heaD_NAME") {
      if (/[^a-zA-Z\s]/.test(newValue)) return;
      newValue = newValue.toUpperCase();
    }

    if (
      name === "schooL_CODE" ||
      name === "telephonE_NO" ||
      name === "piN_CODE" ||
      name === "heaD_MOBILE_NO" ||
      name === "asstistencE_TEACHER_CONTACT" ||
      name === "challaN_LIMIT" ||
      name === "challaN_LIMIT_CL_10" ||
      name === "challaN_LIMIT_S_EXAM_CL_9" ||
      name === "challaN_LIMIT_S_EXAM_CL_10"
    ) {
      if (/[^0-9]/.test(newValue)) return;

      if (
        (name === "telephonE_NO" ||
          name === "heaD_MOBILE_NO" ||
          name === "asstistencE_TEACHER_CONTACT") &&
        newValue.length > 10
      ) {
        return;
      }
      if (name === "piN_CODE" && newValue.length > 6) {
        return;
      }
      if (name === "udisE_CODE" && newValue.length > 15) {
        return;
      }
      if (name === "schooL_CODE" && newValue.length > 5) {
        return;
      }
    }

    if (
      name === "udisE_CODE" ||
      name === "posT_OFFICE" ||
      name === "nearesT_RAILWAY_STATION"
    ) {
      if (/[^a-zA-Z0-9\s]/.test(newValue)) return;
      newValue = newValue.toUpperCase();
    }

    if (name === "emaiL_ADDRESS") {
      newValue = newValue.toLowerCase();
    }
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (name === "udisE_CODE") {
      setSchoolInfo((prev) => ({ ...prev, udisE_CODE: newValue }));
      setSchoolInfoX((prev) => ({ ...prev, udisE_CODE: newValue }));
      if (!newValue.trim()) {
        setUdiseSource("");
      } else {
        setUdiseSource(formType);
      }
      return;
    }

    if (name === "schooL_CODE") {
      setSchoolInfo((prev) => ({ ...prev, schooL_CODE: newValue }));
      setSchoolInfoX((prev) => ({ ...prev, schooL_CODE: newValue }));
      if (!newValue.trim()) {
        setSchoolCodeSource("");
      } else {
        setSchoolCodeSource(formType);
      }
      return;
    }

    if (formType === "10") {
      setSchoolInfoX((prev) => ({ ...prev, [name]: newValue }));
      if (copyDirection === "10to9" && !nonCopyableFields.includes(name)) {
        setSchoolInfo((prev) => ({ ...prev, [name]: newValue }));
      }
      return;
    }

    setSchoolInfo((prev) => ({ ...prev, [name]: newValue }));
    if (copyDirection === "9to10" && !nonCopyableFields.includes(name)) {
      setSchoolInfoX((prev) => ({ ...prev, [name]: newValue }));
    }
  };

  const handlePreview = () => {
    const newErrors = {};
    const trimmed = (val) => String(val || "").trim();

    setLoading(true);

    setTimeout(() => {
      // Class IX UDISE / School Code
      const hasIXUdise = !!trimmed(schoolInfo.udisE_CODE);
      const hasIXSchoolCode = !!trimmed(schoolInfo.schooL_CODE);
      if (!hasIXUdise && !hasIXSchoolCode) {
        newErrors.udisE_CODE = "Either UDISE Code or School Code is required.";
      } else {
        if (hasIXUdise && schoolInfo.udisE_CODE.length > 15) {
          newErrors.udisE_CODE = "Class IX UDISE code cannot exceed 15 characters.";
        }
        if (hasIXSchoolCode && schoolInfo.schooL_CODE.length !== 5) {
          newErrors.schooL_CODE = "Class IX School code must be exactly 5 characters.";
        }
      }

      // Class X UDISE / School Code
      const hasXUdise = !!trimmed(schoolInfoX.udisE_CODE);
      const hasXSchoolCode = !!trimmed(schoolInfoX.schooL_CODE);
      if (!hasXUdise && !hasXSchoolCode) {
        newErrors.udisE_CODEX = "Either UDISE Code or School Code is required.";
      } else {
        if (hasXUdise && schoolInfoX.udisE_CODE.length > 15) {
          newErrors.udisE_CODEX = "Class X UDISE code cannot exceed 15 characters.";
        }
        if (hasXSchoolCode && schoolInfoX.schooL_CODE.length !== 5) {
          newErrors.schooL_CODEX = "Class X School code must be exactly 5 characters.";
        }
      }

      // Class IX Required Fields
      if (!trimmed(schoolInfo.schooL_NAME))
        newErrors.schooL_NAME = "School name is required.";
      if (!trimmed(schoolInfo.sC_ADDRESS))
        newErrors.sC_ADDRESS = "School address is required.";
      if (!selectedState) newErrors.state = "State is required.";
      if (!selectedDistrict) newErrors.districtcode = "District is required.";
      if (!selectedBlock) newErrors.blocK_NAME = "Block is required.";
      if (!trimmed(schoolInfo.heaD_MOBILE_NO)) {
        newErrors.heaD_MOBILE_NO = "Principal mobile no is required.";
      } else if (schoolInfo.heaD_MOBILE_NO.length !== 10) {
        newErrors.heaD_MOBILE_NO = "Principal mobile no must be 10 digits.";
      }
      if (!trimmed(schoolInfo.emaiL_ADDRESS))
        newErrors.emaiL_ADDRESS = "Principal email is required.";

      // Class X Required Fields
      if (!trimmed(schoolInfoX.schooL_NAME))
        newErrors.schooL_NAMEX = "School name for Class X is required.";
      if (!trimmed(schoolInfoX.sC_ADDRESS))
        newErrors.sC_ADDRESSX = "School address for Class X is required.";
      if (!selectedStateX) newErrors.stateX = "State for Class X is required.";
      if (!selectedDistrictX) newErrors.districtcodeX = "District for Class X is required.";
      if (!selectedBlockX) newErrors.blocK_NAMEX = "Block for Class X is required.";
      if (!trimmed(schoolInfoX.heaD_MOBILE_NO)) {
        newErrors.heaD_MOBILE_NOX = "Principal mobile no for Class X is required.";
      } else if (schoolInfoX.heaD_MOBILE_NO.length !== 10) {
        newErrors.heaD_MOBILE_NOX = "Principal mobile no for Class X must be 10 digits.";
      }
      if (!trimmed(schoolInfoX.emaiL_ADDRESS))
        newErrors.emaiL_ADDRESSX = "Principal email for Class X is required.";

      if (schoolInfo.piN_CODE && schoolInfo.piN_CODE.length !== 6) {
        newErrors.piN_CODE = "Pin code must be exactly 6 digits.";
      }
      if (schoolInfoX.piN_CODE && schoolInfoX.piN_CODE.length !== 6) {
        newErrors.piN_CODEX = "Pin code must be exactly 6 digits.";
      }

      // Numbers or strings
      if (!trimmed(schoolInfo.challaN_LIMIT))
        newErrors.challaN_LIMIT =
          "Allowed Number of Challan Generation for class 9 is required.";
      if (!trimmed(schoolInfoX.challaN_LIMIT_CL_10 || schoolInfo.challaN_LIMIT_CL_10))
        newErrors.challaN_LIMIT_CL_10 =
          "Allowed Number of Challan Generation for class 10 is required.";

      setErrors(newErrors);
      setLoading(false);

      if (Object.keys(newErrors).length === 0) {
        setPreviewMode(true);
      }
    }, 500);
  };

  const getPayload9 = () => {
    const updateBy =
      sessionStorage.getItem("secondaryAdminName") ||
      sessionStorage.getItem("schoolCode") ||
      "ADMIN";

    return {
      school_code: schoolInfo.schooL_CODE || "",
      school_name: schoolInfo.schooL_NAME || "",
      sub_division:
        schoolInfo.suB_DIVISION ||
        "",
      sc_address: schoolInfo.sC_ADDRESS || "",
      type_of_school:
        schoolInfo.typE_OF_SCHOOL ||
        "",
      state: schoolInfo.state || "",
      district: schoolInfo.district || "",
      block_name:
        schoolInfo.blocK_NAME ||
        "",
      pin_code: schoolInfo.piN_CODE || "",
      area: schoolInfo.area || "",
      post_office: schoolInfo.posT_OFFICE || "",
      nearest_railway_station:
        schoolInfo.nearesT_RAILWAY_STATION ||
        "",
      telephone_no: schoolInfo.telephonE_NO || "",
      head_mobile_no:
        schoolInfo.heaD_MOBILE_NO || "",
      email_address:
        schoolInfo.emaiL_ADDRESS || "",
      asstistence_teacher_contact:
        schoolInfo.asstistencE_TEACHER_CONTACT ||
        "",
      administration: schoolInfo.administration || "",
      head_name: schoolInfo.heaD_NAME || "",
      challan_limit:
        Number(schoolInfo.challaN_LIMIT) || 0,
      update_by: updateBy,
      udise_code: schoolInfo.udisE_CODE || "",
      admission_count:
        Number(schoolInfo.admissioN_COUNT) || 0,
      challan_limit_s_exam_cl_9:
        Number(
          schoolInfo.challaN_LIMIT_S_EXAM_CL_9) || 0,
    };
  };

  const getPayload10 = () => {
    const updateBy =
      sessionStorage.getItem("secondaryAdminName") ||
      sessionStorage.getItem("schoolCode") ||
      "ADMIN";

    return {
      schooL_CODE:
        schoolInfoX.schooL_CODE ||
        "",
      schooL_NAME: schoolInfoX.schooL_NAME || "",
      suB_DIVISION:
        schoolInfoX.suB_DIVISION ||
        "",
      sC_ADDRESS: schoolInfoX.sC_ADDRESS || "",
      typE_OF_SCHOOL:
        schoolInfoX.typE_OF_SCHOOL ||
        "",
      state:
        schoolInfoX.state ||
        "",
      district:
        schoolInfoX.district ||
        "",
      blocK_NAME:
        schoolInfoX.blocK_NAME ||
        "",
      piN_CODE: schoolInfoX.piN_CODE || "",
      area: schoolInfoX.area || "",
      posT_OFFICE: schoolInfoX.posT_OFFICE || "",
      nearesT_RAILWAY_STATION:
        schoolInfoX.nearesT_RAILWAY_STATION ||
        "",
      telephonE_NO:
        schoolInfoX.telephonE_NO || "",
      heaD_MOBILE_NO:
        schoolInfoX.heaD_MOBILE_NO || "",
      emaiL_ADDRESS:
        schoolInfoX.emaiL_ADDRESS || "",
      asstistencE_TEACHER_CONTACT:
        schoolInfoX.asstistencE_TEACHER_CONTACT ||
        "",
      administration: schoolInfoX.administration || "",
      heaD_NAME: schoolInfoX.heaD_NAME || "",
      challaN_LIMIT_CL_10:
        Number(
          schoolInfoX.challaN_LIMIT_CL_10) || 0,
      updatE_BY: updateBy,
      udisE_CODE:
        schoolInfoX.udisE_CODE ||
        schoolInfo.udisE_CODE ||
        "",
      admissioN_COUNT:
        Number(schoolInfoX.admissioN_COUNT) || 0,
      challaN_LIMIT_S_EXAM_CL_10:
        Number(
          schoolInfoX.challaN_LIMIT_S_EXAM_CL_10) || 0,
    };
  };

  const handleUpdateClass9 = async () => {
    const trimmed = (val) => String(val || "").trim();
    const newErrors = {};

    const hasIXUdise = !!trimmed(schoolInfo.udisE_CODE);
    const hasIXSchoolCode = !!trimmed(schoolInfo.schooL_CODE);
    if (!hasIXUdise && !hasIXSchoolCode) {
      newErrors.udisE_CODE = "Either UDISE Code or School Code is required.";
    }
    if (!trimmed(schoolInfo.schooL_NAME)) newErrors.schooL_NAME = "School name is required.";
    if (!trimmed(schoolInfo.sC_ADDRESS)) newErrors.sC_ADDRESS = "School address is required.";
    if (!selectedState) newErrors.state = "State is required.";
    if (!selectedDistrict) newErrors.districtcode = "District is required.";
    if (!selectedBlock) newErrors.blocK_NAME = "Block is required.";
    if (!trimmed(schoolInfo.heaD_MOBILE_NO)) {
      newErrors.heaD_MOBILE_NO = "Principal mobile no is required.";
    } else if (schoolInfo.heaD_MOBILE_NO.length !== 10) {
      newErrors.heaD_MOBILE_NO = "Principal mobile no must be 10 digits.";
    }
    if (!trimmed(schoolInfo.emaiL_ADDRESS)) newErrors.emaiL_ADDRESS = "Principal email is required.";

    if (Object.keys(newErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...newErrors }));
      Swal.fire("Validation Error", "Please fill all required Class IX fields correctly.", "warning");
      return;
    }

    const confirm = await Swal.fire({
      title: "Update Class IX School Data?",
      text: "Do you really want to save changes for Class IX?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Update IX",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);
    try {
      const payload9 = getPayload9();
      const response = await fetch(
        `${config.API_BASE_URL}/AdminUpdateSchoolDataCL9`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload9),
        }
      );

      const result = await response.json();
      setLoading(false);

      if (response.ok && (result.status === 200 || result.status === "200" || result.isSuccess)) {
        Swal.fire("Success", result.message || "Class IX school details updated successfully!", "success");
      } else {
        Swal.fire("Error", result.message || "Failed to update Class IX school details.", "error");
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      Swal.fire("Error", "Something went wrong while updating Class IX school details.", "error");
    }
  };

  const handleUpdateClass10 = async () => {
    const trimmed = (val) => String(val || "").trim();
    const newErrors = {};

    const hasXUdise = !!trimmed(schoolInfoX.udisE_CODE || schoolInfo.udisE_CODE);
    const hasXSchoolCode = !!trimmed(schoolInfoX.schooL_CODE || schoolInfo.schooL_CODE);
    if (!hasXUdise && !hasXSchoolCode) {
      newErrors.udisE_CODEX = "Either UDISE Code or School Code is required.";
    }
    if (!trimmed(schoolInfoX.schooL_NAME)) newErrors.schooL_NAMEX = "School name for Class X is required.";
    if (!trimmed(schoolInfoX.sC_ADDRESS)) newErrors.sC_ADDRESSX = "School address for Class X is required.";
    if (!selectedStateX && !selectedState) newErrors.stateX = "State for Class X is required.";
    if (!selectedDistrictX && !selectedDistrict) newErrors.districtcodeX = "District for Class X is required.";
    if (!selectedBlockX && !selectedBlock) newErrors.blocK_NAMEX = "Block for Class X is required.";
    if (!trimmed(schoolInfoX.heaD_MOBILE_NO)) {
      newErrors.heaD_MOBILE_NOX = "Principal mobile no for Class X is required.";
    } else if (schoolInfoX.heaD_MOBILE_NO.length !== 10) {
      newErrors.heaD_MOBILE_NOX = "Principal mobile no for Class X must be 10 digits.";
    }
    if (!trimmed(schoolInfoX.emaiL_ADDRESS)) newErrors.emaiL_ADDRESSX = "Principal email for Class X is required.";

    if (Object.keys(newErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...newErrors }));
      Swal.fire("Validation Error", "Please fill all required Class X fields correctly.", "warning");
      return;
    }

    const confirm = await Swal.fire({
      title: "Update Class X School Data?",
      text: "Do you really want to save changes for Class X?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Update X",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);
    try {
      const payload10 = getPayload10();
      const apiUrl10 = config.API_BASE_URL2;
      const response = await fetch(
        `${apiUrl10}/AdminUpdateSchoolDataCL10`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload10),
        }
      );

      const result = await response.json();
      setLoading(false);

      if (response.ok && (result.status === 200 || result.status === "200" || result.isSuccess)) {
        Swal.fire("Success", result.message || "Class X school details updated successfully!", "success");
      } else {
        Swal.fire("Error", result.message || "Failed to update Class X school details.", "error");
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      Swal.fire("Error", "Something went wrong while updating Class X school details.", "error");
    }
  };

  const handleEdit = () => {
    setPreviewMode(false);
  };

  const handleSubmit = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to save the changes for Class IX and Class X?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Save All",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);

    const payload9 = getPayload9();
    const payload10 = getPayload10();
    const apiUrl10 = config.API_BASE_URL2;

    try {
      let class9Success = false;
      let class10Success = false;
      let class9Msg = "";
      let class10Msg = "";

      // 1. Update Class 9
      try {
        const response9 = await fetch(
          `${config.API_BASE_URL}/AdminUpdateSchoolDataCL9`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload9),
          }
        );

        const result9 = await response9.json();
        if (response9.ok && (result9.status === 200 || result9.status === "200" || result9.isSuccess)) {
          class9Success = true;
          class9Msg = result9.message || "Class IX updated successfully.";
        } else {
          class9Msg = result9.message || "Failed to update Class IX.";
        }
      } catch (e9) {
        class9Msg = "Error updating Class IX: " + e9.message;
      }

      // 2. Update Class 10
      try {
        const response10 = await fetch(
          `${apiUrl10}/AdminUpdateSchoolDataCL10`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload10),
          }
        );

        const result10 = await response10.json();
        if (response10.ok && (result10.status === 200 || result10.status === "200" || result10.isSuccess)) {
          class10Success = true;
          class10Msg = result10.message || "Class X updated successfully.";
        } else {
          class10Msg = result10.message || "Failed to update Class X.";
        }
      } catch (e10) {
        class10Msg = "Error updating Class X: " + e10.message;
      }

      setLoading(false);

      if (class9Success && class10Success) {
        Swal.fire(
          "Success",
          "School data updated successfully for Class IX and Class X",
          "success"
        ).then(() => {
          navigate("/secondary-admin-school-list");
        });
      } else if (class9Success || class10Success) {
        Swal.fire(
          "Partial Success",
          `Class IX: ${class9Msg}\nClass X: ${class10Msg}`,
          "warning"
        ).then(() => {
          navigate("/secondary-admin-school-list");
        });
      } else {
        Swal.fire(
          "Error",
          `Failed to update school data.\nClass IX: ${class9Msg}\nClass X: ${class10Msg}`,
          "error"
        );
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      Swal.fire("Error", "Something went wrong during submission", "error");
    }
  };

  return (
    <div className="container-scroller">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-university" />
                    &nbsp;Edit School
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        onClick={() => navigate("/secondary-admin-dashboard")}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className="fa fa-tachometer"
                          style={{ marginRight: "5px" }}
                        ></i>{" "}
                        Home
                      </a>
                    </li>
                    <li className="active">Secondary Admin Edit School</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row">
              {/* Class IX Details Card */}
              <div className="col-md-12 mb-4 stretch-card">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="mb-0 p-2">Enter School Details for Class IX</h4>
                    <div className="d-flex align-items-center gap-3">
                      <label className="mb-0 d-flex align-items-center gap-2" style={{ fontSize: 14, fontWeight: 600 }}>
                        <input
                          type="checkbox"
                          checked={copyDirection === "10to9"}
                          onChange={() => toggleCopyDirection("10to9")}
                        />
                        Copy from X to IX
                      </label>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* Left side: School Info (col-md-9) */}
                      <div className="col-md-9">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                UDISE Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors.udisE_CODE ? "is-invalid" : ""}`}
                                value={schoolInfo.udisE_CODE || ""}
                                name="udisE_CODE"
                                onChange={handleInputChange}
                                disabled={isDisabled || udiseSource === "10"}
                                maxLength={50}
                              />
                              {errors.udisE_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.udisE_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Name of School{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="schooL_NAME"
                                className={`form-control form-control-sm ${errors.schooL_NAME ? "is-invalid" : ""}`}
                                value={schoolInfo.schooL_NAME || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.schooL_NAME && (
                                <div className="text-danger mt-1 small">
                                  {errors.schooL_NAME}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Type of School</label>
                              <Select
                                value={typeofschool}
                                onChange={(selected) => {
                                  setTypeofschool(selected);
                                  setSchoolInfo((prev) => ({
                                    ...prev,
                                    typE_OF_SCHOOL: selected?.value || "",
                                  }));
                                }}
                                options={typeOfSchoolOptions}
                                isDisabled={isDisabled}
                                classNamePrefix="react-select"
                                placeholder="Select Type"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                School Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors.schooL_CODE ? "is-invalid" : ""}`}
                                value={schoolInfo.schooL_CODE || ""}
                                name="schooL_CODE"
                                onChange={handleInputChange}
                                disabled={true}
                                maxLength={5}
                              />
                              {errors.schooL_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.schooL_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                School Address{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="sC_ADDRESS"
                                className={`form-control form-control-sm ${errors.sC_ADDRESS ? "is-invalid" : ""}`}
                                value={schoolInfo.sC_ADDRESS || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.sC_ADDRESS && (
                                <div className="text-danger mt-1 small">
                                  {errors.sC_ADDRESS}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                State <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  stateList,
                                  "statE_CODE",
                                  "statE_NAME"
                                )}
                                value={selectedState}
                                onChange={(val) =>
                                  handleSelectChange("state", val)
                                }
                                placeholder="Select State"
                                isDisabled={isDisabled}
                                className={errors.state ? "is-invalid" : ""}
                              />
                              {errors.state && (
                                <div className="text-danger mt-1 small">
                                  {errors.state}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                District <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  filteredDistricts,
                                  "districT_CODE",
                                  "district"
                                )}
                                value={selectedDistrict}
                                onChange={(val) =>
                                  handleSelectChange("district", val)
                                }
                                isDisabled={!selectedState || isDisabled}
                                placeholder="Select District"
                                className={
                                  errors.districtcode ? "is-invalid" : ""
                                }
                              />
                              {errors.districtcode && (
                                <div className="text-danger mt-1 small">
                                  {errors.districtcode}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Block <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  filteredBlocks,
                                  "blocK_ID",
                                  "blocK_NAME"
                                )}
                                value={selectedBlock}
                                onChange={(val) =>
                                  handleSelectChange("block", val)
                                }
                                isDisabled={!selectedDistrict || isDisabled}
                                placeholder="Select Block"
                                className={
                                  errors.blocK_NAME ? "is-invalid" : ""
                                }
                              />
                              {errors.blocK_NAME && (
                                <div className="text-danger mt-1 small">
                                  {errors.blocK_NAME}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Sub Division </label>
                              <Select
                                options={toOptions(
                                  filteredSubDivisions,
                                  "divisioN_ID",
                                  "divisioN_NAME"
                                )}
                                value={selectedSubDivision}
                                onChange={(val) =>
                                  handleSelectChange("subdivision", val)
                                }
                                isDisabled={!selectedDistrict || isDisabled}
                                placeholder="Select Subdivision"
                                className={
                                  errors.suB_DIVISION ? "is-invalid" : ""
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Pin Code</label>
                              <input
                                type="text"
                                name="piN_CODE"
                                className={`form-control form-control-sm ${errors.piN_CODE ? "is-invalid" : ""}`}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={schoolInfo.piN_CODE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={6}
                              />
                              {errors.piN_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.piN_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Area</label>
                              <select
                                name="area"
                                className={`form-control form-select ${errors.area ? "is-invalid" : ""}`}
                                value={schoolInfo.area || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="RURAL">Rural</option>
                                <option value="URBAN">Urban</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Post Office</label>
                              <input
                                type="text"
                                name="posT_OFFICE"
                                className={`form-control form-control-sm ${errors.posT_OFFICE ? "is-invalid" : ""}`}
                                value={schoolInfo.posT_OFFICE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Nearest Railway Station </label>
                              <input
                                type="text"
                                name="nearesT_RAILWAY_STATION"
                                className={`form-control form-control-sm ${errors.nearesT_RAILWAY_STATION ? "is-invalid" : ""}`}
                                value={schoolInfo.nearesT_RAILWAY_STATION || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                              {errors.nearesT_RAILWAY_STATION && (
                                <div className="text-danger mt-1 small">
                                  {errors.nearesT_RAILWAY_STATION}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class 9
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class9limit;
                                    if (
                                      (parseInt(schoolInfo.challaN_LIMIT) || 0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT",
                                          value:
                                            (parseInt(schoolInfo.challaN_LIMIT) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>
                                <input
                                  type="number"
                                  name="challaN_LIMIT"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT ? "is-invalid" : ""}`}
                                  value={schoolInfo.challaN_LIMIT || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class9limit}
                                />
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT",
                                        value:
                                          (parseInt(schoolInfo.challaN_LIMIT) || 0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class 9 Special Exam
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class9limitspecialexam;
                                    if (
                                      (parseInt(schoolInfo.challaN_LIMIT_S_EXAM_CL_9) || 0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_S_EXAM_CL_9",
                                          value:
                                            (parseInt(schoolInfo.challaN_LIMIT_S_EXAM_CL_9) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>

                                <input
                                  type="number"
                                  name="challaN_LIMIT_S_EXAM_CL_9"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_S_EXAM_CL_9 ? "is-invalid" : ""}`}
                                  value={schoolInfo.challaN_LIMIT_S_EXAM_CL_9 || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class9limitspecialexam}
                                />

                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_S_EXAM_CL_9",
                                        value:
                                          (parseInt(schoolInfo.challaN_LIMIT_S_EXAM_CL_9) || 0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_S_EXAM_CL_9 && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_S_EXAM_CL_9}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right side: Principal Info (col-md-3) */}
                      <div
                        className="col-md-3"
                        style={{ borderLeft: "1px solid gray" }}
                      >
                        <div className="form-group mb-3">
                          <label>Principal Name </label>
                          <input
                            type="text"
                            name="heaD_NAME"
                            className={`form-control form-control-sm ${errors.heaD_NAME ? "is-invalid" : ""}`}
                            value={schoolInfo.heaD_NAME || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={50}
                          />
                          {errors.heaD_NAME && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_NAME}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Mobile No{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="heaD_MOBILE_NO"
                            className={`form-control form-control-sm ${errors.heaD_MOBILE_NO ? "is-invalid" : ""}`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfo.heaD_MOBILE_NO || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.heaD_MOBILE_NO && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_MOBILE_NO}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Email Address{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            name="emaiL_ADDRESS"
                            className={`form-control form-control-sm ${errors.emaiL_ADDRESS ? "is-invalid" : ""}`}
                            value={schoolInfo.emaiL_ADDRESS || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={100}
                          />
                          {errors.emaiL_ADDRESS && (
                            <div className="text-danger mt-1 small">
                              {errors.emaiL_ADDRESS}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>Assistant Teacher Mobile No</label>
                          <input
                            type="text"
                            name="asstistencE_TEACHER_CONTACT"
                            className={`form-control form-control-sm ${errors.asstistencE_TEACHER_CONTACT ? "is-invalid" : ""}`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfo.asstistencE_TEACHER_CONTACT || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.asstistencE_TEACHER_CONTACT && (
                            <div className="text-danger mt-1 small">
                              {errors.asstistencE_TEACHER_CONTACT}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Class X Details Card */}
              <div className="col-md-12 mb-4 stretch-card">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="mb-0 p-2">Enter School Details for Class X</h4>
                    <div className="d-flex align-items-center gap-3">
                      <label className="mb-0 d-flex align-items-center gap-2" style={{ fontSize: 14, fontWeight: 600 }}>
                        <input
                          type="checkbox"
                          checked={copyDirection === "9to10"}
                          onChange={() => toggleCopyDirection("9to10")}
                        />
                        Copy from IX to X
                      </label>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* Left side: School Info (col-md-9) */}
                      <div className="col-md-9">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                UDISE Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors.udisE_CODEX || errors.udisE_CODE ? "is-invalid" : ""}`}
                                value={schoolInfoX.udisE_CODE || ""}
                                name="udisE_CODE"
                                data-form-type="10"
                                onChange={handleInputChange}
                                disabled={isDisabled || udiseSource === "9"}
                                maxLength={50}
                              />
                              {(errors.udisE_CODEX || errors.udisE_CODE) && (
                                <div className="text-danger mt-1 small">{errors.udisE_CODEX || errors.udisE_CODE}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Name of School{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="schooL_NAME"
                                className={`form-control form-control-sm ${errors.schooL_NAMEX ? "is-invalid" : ""}`}
                                value={schoolInfoX.schooL_NAME || ""}
                                data-form-type="10"
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.schooL_NAMEX && (
                                <div className="text-danger mt-1 small">{errors.schooL_NAMEX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Type of School</label>
                              <Select
                                value={typeofschoolX}
                                onChange={(selected) => {
                                  setTypeofschoolX(selected);
                                  setSchoolInfoX((prev) => ({
                                    ...prev,
                                    typE_OF_SCHOOL: selected?.value || "",
                                  }));
                                }}
                                options={typeOfSchoolOptionsX}
                                isDisabled={isDisabled}
                                classNamePrefix="react-select"
                                placeholder="Select Type"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                School Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors.schooL_CODEX || errors.schooL_CODE ? "is-invalid" : ""}`}
                                value={schoolInfoX.schooL_CODE || ""}
                                name="schooL_CODE"
                                data-form-type="10"
                                onChange={handleInputChange}
                                disabled={true}
                                maxLength={5}
                              />
                              {(errors.schooL_CODEX || errors.schooL_CODE) && (
                                <div className="text-danger mt-1 small">{errors.schooL_CODEX || errors.schooL_CODE}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                School Address{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="sC_ADDRESS"
                                className={`form-control form-control-sm ${errors.sC_ADDRESSX ? "is-invalid" : ""}`}
                                value={schoolInfoX.sC_ADDRESS || ""}
                                data-form-type="10"
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.sC_ADDRESSX && (
                                <div className="text-danger mt-1 small">{errors.sC_ADDRESSX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                State <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(stateListX, "statE_CODE", "statE_NAME")}
                                value={selectedStateX}
                                onChange={(val) => handleSelectChangeX("state", val)}
                                placeholder="Select State"
                                isDisabled={isDisabled}
                                className={errors.stateX ? "is-invalid" : ""}
                              />
                              {errors.stateX && (
                                <div className="text-danger mt-1 small">{errors.stateX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                District <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(filteredDistrictsX, "districT_CODE", "district")}
                                value={selectedDistrictX}
                                onChange={(val) => handleSelectChangeX("district", val)}
                                isDisabled={!selectedStateX || isDisabled}
                                placeholder="Select District"
                                className={errors.districtcodeX ? "is-invalid" : ""}
                              />
                              {errors.districtcodeX && (
                                <div className="text-danger mt-1 small">{errors.districtcodeX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Block <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(filteredBlocksX, "blocK_ID", "blocK_NAME")}
                                value={selectedBlockX}
                                onChange={(val) => handleSelectChangeX("block", val)}
                                isDisabled={!selectedDistrictX || isDisabled}
                                placeholder="Select Block"
                                className={errors.blocK_NAMEX ? "is-invalid" : ""}
                              />
                              {errors.blocK_NAMEX && (
                                <div className="text-danger mt-1 small">{errors.blocK_NAMEX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Sub Division </label>
                              <Select
                                options={toOptions(filteredSubDivisionsX, "divisioN_ID", "divisioN_NAME")}
                                value={selectedSubDivisionX}
                                onChange={(val) => handleSelectChangeX("subdivision", val)}
                                isDisabled={!selectedDistrictX || isDisabled}
                                placeholder="Select Subdivision"
                                className={errors.suB_DIVISION ? "is-invalid" : ""}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Pin Code</label>
                              <input
                                type="text"
                                name="piN_CODE"
                                data-form-type="10"
                                className={`form-control form-control-sm ${errors.piN_CODEX ? "is-invalid" : ""}`}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={schoolInfoX.piN_CODE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={6}
                              />
                              {errors.piN_CODEX && (
                                <div className="text-danger mt-1 small">
                                  {errors.piN_CODEX}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Area</label>
                              <select
                                name="area"
                                data-form-type="10"
                                className={`form-control form-select ${errors.area ? "is-invalid" : ""}`}
                                value={schoolInfoX.area || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="RURAL">Rural</option>
                                <option value="URBAN">Urban</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Post Office</label>
                              <input
                                type="text"
                                name="posT_OFFICE"
                                data-form-type="10"
                                className={`form-control form-control-sm ${errors.posT_OFFICE ? "is-invalid" : ""}`}
                                value={schoolInfoX.posT_OFFICE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Nearest Railway Station </label>
                              <input
                                type="text"
                                name="nearesT_RAILWAY_STATION"
                                data-form-type="10"
                                className={`form-control form-control-sm ${errors.nearesT_RAILWAY_STATION ? "is-invalid" : ""}`}
                                value={schoolInfoX.nearesT_RAILWAY_STATION || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                              {errors.nearesT_RAILWAY_STATION && (
                                <div className="text-danger mt-1 small">
                                  {errors.nearesT_RAILWAY_STATION}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class 10
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class10limit;
                                    const currentVal = parseInt(schoolInfoX.challaN_LIMIT_CL_10 || schoolInfo.challaN_LIMIT_CL_10) || 0;
                                    if (currentVal > minValue) {
                                      const newVal = currentVal - 1;
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_CL_10",
                                          value: newVal,
                                          dataset: { formType: "10" },
                                        },
                                      });
                                      setSchoolInfo((prev) => ({
                                        ...prev,
                                        challaN_LIMIT_CL_10: String(newVal),
                                      }));
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>

                                <input
                                  type="number"
                                  name="challaN_LIMIT_CL_10"
                                  data-form-type="10"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_CL_10 ? "is-invalid" : ""}`}
                                  value={schoolInfoX.challaN_LIMIT_CL_10 || schoolInfo.challaN_LIMIT_CL_10 || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class10limit}
                                />

                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    const currentVal = parseInt(schoolInfoX.challaN_LIMIT_CL_10 || schoolInfo.challaN_LIMIT_CL_10) || 0;
                                    const newVal = currentVal + 1;
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_CL_10",
                                        value: newVal,
                                        dataset: { formType: "10" },
                                      },
                                    });
                                    setSchoolInfo((prev) => ({
                                      ...prev,
                                      challaN_LIMIT_CL_10: String(newVal),
                                    }));
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_CL_10 && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_CL_10}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class 10 Special Exam
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class10limitspecialexam;
                                    const currentVal = parseInt(schoolInfoX.challaN_LIMIT_S_EXAM_CL_10 || schoolInfo.challaN_LIMIT_S_EXAM_CL_10) || 0;
                                    if (currentVal > minValue) {
                                      const newVal = currentVal - 1;
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_S_EXAM_CL_10",
                                          value: newVal,
                                          dataset: { formType: "10" },
                                        },
                                      });
                                      setSchoolInfo((prev) => ({
                                        ...prev,
                                        challaN_LIMIT_S_EXAM_CL_10: String(newVal),
                                      }));
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>

                                <input
                                  type="number"
                                  name="challaN_LIMIT_S_EXAM_CL_10"
                                  data-form-type="10"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_S_EXAM_CL_10 ? "is-invalid" : ""}`}
                                  value={schoolInfoX.challaN_LIMIT_S_EXAM_CL_10 || schoolInfo.challaN_LIMIT_S_EXAM_CL_10 || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class10limitspecialexam}
                                />

                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    const currentVal = parseInt(schoolInfoX.challaN_LIMIT_S_EXAM_CL_10 || schoolInfo.challaN_LIMIT_S_EXAM_CL_10) || 0;
                                    const newVal = currentVal + 1;
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_S_EXAM_CL_10",
                                        value: newVal,
                                        dataset: { formType: "10" },
                                      },
                                    });
                                    setSchoolInfo((prev) => ({
                                      ...prev,
                                      challaN_LIMIT_S_EXAM_CL_10: String(newVal),
                                    }));
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_S_EXAM_CL_10 && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_S_EXAM_CL_10}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right side: Principal Info (col-md-3) */}
                      <div
                        className="col-md-3"
                        style={{ borderLeft: "1px solid gray" }}
                      >
                        <div className="form-group mb-3">
                          <label>Principal Name </label>
                          <input
                            type="text"
                            name="heaD_NAME"
                            data-form-type="10"
                            className={`form-control form-control-sm ${errors.heaD_NAME ? "is-invalid" : ""}`}
                            value={schoolInfoX.heaD_NAME || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={50}
                          />
                          {errors.heaD_NAME && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_NAME}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Mobile No{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="heaD_MOBILE_NO"
                            data-form-type="10"
                            className={`form-control form-control-sm ${errors.heaD_MOBILE_NOX ? "is-invalid" : ""}`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfoX.heaD_MOBILE_NO || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.heaD_MOBILE_NOX && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_MOBILE_NOX}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Email Address{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            name="emaiL_ADDRESS"
                            data-form-type="10"
                            className={`form-control form-control-sm ${errors.emaiL_ADDRESSX ? "is-invalid" : ""}`}
                            value={schoolInfoX.emaiL_ADDRESS || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={100}
                          />
                          {errors.emaiL_ADDRESSX && (
                            <div className="text-danger mt-1 small">
                              {errors.emaiL_ADDRESSX}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>Assistant Teacher Mobile No</label>
                          <input
                            type="text"
                            name="asstistencE_TEACHER_CONTACT"
                            data-form-type="10"
                            className={`form-control form-control-sm ${errors.asstistencE_TEACHER_CONTACT ? "is-invalid" : ""}`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfoX.asstistencE_TEACHER_CONTACT || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.asstistencE_TEACHER_CONTACT && (
                            <div className="text-danger mt-1 small">
                              {errors.asstistencE_TEACHER_CONTACT}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action buttons */}
              <div className="col-md-12 stretch-card">
                <div className="card">
                  <div className="card-body">
                    {previewMode ? (
                      <>
                        <button
                          className="btn btn-primary me-2"
                          style={{ float: "right" }}
                          onClick={handleSubmit}
                        >
                          <i className="fa fa-save" /> Save
                        </button>
                        <button
                          className="btn btn-info me-2"
                          style={{ float: "right" }}
                          onClick={handleEdit}
                        >
                          <i className="fa fa-edit" /> Edit
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn btn-secondary me-2"
                        style={{ float: "right" }}
                        onClick={handlePreview}
                      >
                        <i className="fa fa-eye" /> Preview
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default EditSchool;

